import API from "services/api";
import configureStore from "./configure";

const store = configureStore({}, { api: new API() });

export default store;
